import { render } from "./RadioView.vue?vue&type=template&id=66a95824&scoped=true"
import script from "./RadioView.vue?vue&type=script&lang=js"
export * from "./RadioView.vue?vue&type=script&lang=js"

import "./RadioView.vue?vue&type=style&index=0&id=66a95824&scoped=true&lang=css"

import exportComponent from "C:\\Work\\huabiao-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a95824"]])

export default __exports__